module.exports = __webpack_public_path__ + "img/96.2ab2bde0.webp";